import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { RootState } from '../store';

interface Props {
  allowed: Array<'merchant' | 'wave' | 'bank'>;
}

const RoleRoute: React.FC<Props> = ({ allowed }) => {
  const user = useSelector((s: RootState) => s.auth.user);
  if (!user) return <Navigate to="/login" replace />;
  return allowed.includes(user.role) ? <Outlet /> : <Navigate to="/" replace />;
};

export default RoleRoute;

